// ... existing code ...
import { giftDiagnosisSteps } from "@/mocks/homeData";

export default function GiftDiagnosisSection() {
  return (
    <div id="diagnosis" className="bg-white rounded-xl border border-background-200 p-5 md:p-6">
      <div className="text-center mb-5">
        <div className="flex items-center justify-center gap-1 mb-2">
          <i className="ri-question-line text-accent-500 text-lg"></i>
          <span className="text-xs font-bold text-accent-500">迷ったらこれ！</span>
        </div>
        <h3 className="text-base font-bold text-foreground-950 mb-1">
          プレゼント診断
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed">
          簡単な質問に答えるだけで
          <br />
          お子さんにぴったりのプレゼントが見つかる♪
        </p>
      </div>

      <button className="w-full bg-primary-500 text-white py-3 rounded-full font-bold text-sm hover:bg-primary-600 transition-colors mb-5">
        診断をはじめる
        <i className="ri-arrow-right-s-line ml-1"></i>
      </button>

      {/* Steps */}
      <div className="flex items-center justify-between relative">
        {giftDiagnosisSteps.map((step, index) => (
          <div key={step.id} className="flex flex-col items-center gap-1.5 relative z-10">
            <div className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center">
              <i className={`${step.icon} text-sm text-foreground-500`}></i>
            </div>
            <span className="text-[10px] text-foreground-600 text-center leading-tight">
              {step.label}
            </span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mt-2 px-4">
        {giftDiagnosisSteps.map((step, index) => (
          <div key={`dot-${step.id}`} className="flex items-center flex-1">
            <div className="w-2 h-2 rounded-full bg-background-300 shrink-0"></div>
            {index < giftDiagnosisSteps.length - 1 && (
              <div className="flex-1 h-px bg-background-200 mx-1"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}